export const normalizePredictionOutput = (prediction) => {
    if (prediction === null || prediction === undefined) {
        return '';
    }

    if (typeof prediction === 'string') {
        return prediction;
    }

    if (typeof prediction === 'number' || typeof prediction === 'boolean') {
        console.warn('LLM output is not a string. Converting scalar to string before rendering.', prediction);
        return String(prediction);
    }

    try {
        if (Array.isArray(prediction)) {
            console.warn('LLM output is an array. Stringifying before rendering.', prediction);
            return JSON.stringify(prediction, null, 2);
        }

        if (typeof prediction === 'object') {
            console.warn('LLM output is an object. Stringifying before rendering.', prediction);
            if (typeof prediction.text === 'string') {
                return prediction.text;
            }

            if (typeof prediction.content === 'string') {
                return prediction.content;
            }

            return JSON.stringify(prediction, null, 2);
        }
    } catch (error) {
        console.warn('Failed to stringify LLM output. Falling back to default string conversion.', {
            prediction,
            error
        });
    }

    return String(prediction);
};
